import SingleButtonSelection from "common/bit/SingleButtonSelection"
import { Dispatch, SetStateAction } from "react"
import styled from "styled-components"
import { TypographyRtl } from "theme/shared"

const StyledWrapper = styled.div`
  max-width: 100vw;
  white-space: nowrap;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  margin-bottom: 10px;
  ${(p) => p.theme.breakpoints.up("md")} {
    /* width: 320px; */
    margin: 0 auto;
    margin-bottom: 10px;
  }
`

const StyledSingleButtonSelection = styled(SingleButtonSelection)`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  background-color: ${(p) => p.theme.colors.white};
  border-radius: 3px;
  button {
    width: auto;
  }
`
const StyledButton = styled.label<{ $activeButton: boolean }>`
  cursor: pointer;
  width: 100%;
  height: 100%;
  :focus {
    outline: none;
  }
`

const StyleChipButton = styled.div<{ $activeButton: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px 16px;
  border-radius: 3px;
  min-width: 88px;
  background-color: ${(p) =>
    p.$activeButton ? p.theme.colors.black : p.theme.colors.white};
  p {
    color: ${(p) =>
      p.$activeButton ? p.theme.colors.white : p.theme.colors.black};
  }
`

const StyledText = styled(TypographyRtl).attrs({ variant: "body2" })`
  letter-spacing: 0.05em;
`

type ToggleButtonsProps = {
  activeButton: number
  setActiveButton: Dispatch<SetStateAction<number>>
  optionsList: string[]
  toggleId: string
  className?: string
  onSelect?: () => void
}

const BigChipsOneRow = ({
  activeButton,
  setActiveButton,
  optionsList,
  toggleId,
  className,
  onSelect,
}: ToggleButtonsProps) => {
  return (
    <StyledWrapper className={className}>
      <StyledSingleButtonSelection
        id={toggleId}
        itemsPerRow="auto"
        items={optionsList.map((item, index) => ({
          value: index,
          name: item,
        }))}
        selectedValue={activeButton}
        onSelect={(code) => {
          if (onSelect) {
            onSelect?.()
          }
          setActiveButton(Number(code))
        }}
        customButton={(radioId, isSelected, item) => (
          <StyledButton htmlFor={radioId} $activeButton={isSelected}>
            <StyleChipButton $activeButton={isSelected}>
              <StyledText variant="body2">מנוע {item.name}</StyledText>
            </StyleChipButton>
          </StyledButton>
        )}
      />
    </StyledWrapper>
  )
}

export default BigChipsOneRow
